import { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'list',
    name: 'project.geojson.list',
    component: () => import('@/views/control-panel/projects/project/geojson/List.vue'),
  }
]

export default routes
